import { Toggle } from '@augmentt-dev/ui-components'
import PropTypes from 'prop-types'
import React, { memo } from 'react'

function PolicyToggleField({ id, onChange, values = false, errors = [] }) {
  return (
    <>
      <Toggle id={id} checked={Boolean(values)} onChange={onChange} ariaLabel={id} />
      {errors.map((errorMessage) => (
        <div key={errorMessage} className="text-color-danger mb-2">
          {errorMessage}
        </div>
      ))}
    </>
  )
}

PolicyToggleField.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
}

export default memo(PolicyToggleField)
